import {defaultCellRenderer, EntityMainNameDefaultString} from "../../../../other/utils/utils.jsx";

const AlertNotificationBannerItemPopover = ({ alertItem, boundingClientRect }) => {
  const alertRecipients = alertItem.reminderRecipientValues?.map((recipientResource) => (
    <span key={recipientResource?.id} dangerouslySetInnerHTML={{ __html: EntityMainNameDefaultString(recipientResource) }} />
  ));
  return (
    <div className="banner-item-detail-popover" style={{ left: `${boundingClientRect.left + (boundingClientRect.width / 2) - 100}px`, top: `${boundingClientRect.bottom}px` }}>
      <span className="detail-popover-content-from">From</span>
      <span>{defaultCellRenderer({ value: alertItem.createdBy?.trim() })}</span>
      <span className="detail-popover-content-to">To</span>
      <div className="detail-popover-content-users">
        {alertRecipients?.length ? alertRecipients: defaultCellRenderer({ value: null })}
      </div>
    </div>
  )
}

export default AlertNotificationBannerItemPopover;